import it from 'translations/find-your-phone/it.json';
import en from 'translations/find-your-phone/en.json';
import de from 'translations/find-your-phone/de.json';
import es from 'translations/find-your-phone/es.json';
import fr from 'translations/find-your-phone/fr.json';

export const TRANSLATIONS = {
    it, en, de, es, fr
}